import React from 'react';
import {translate} from "react-i18next";
import LogbookApi from "../../apis/LogbookApi";

class AddInformation extends React.Component {

    state = {
        message: '',
        loading: false,
        errors: {}
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({loading: true, errors: {}});
        LogbookApi.addEntry({
            type: 'INFO',
            message: this.state.message
        }).then((result) => {
            if (result.data.success === true) {
                this.props.handleClose();
            } else {
                this.setState({
                    errors: result.data.errors,
                    loading: false
                });
            }
        });
    };

    render() {
        const {t} = this.props;
        return (
            <div className="entry entry-new" key="entry-new">
                <form onSubmit={this.handleSubmit}>
                    <div
                        className={"form-group" + ((this.state.errors && this.state.errors.message) ? ' has-error' : '')}>
                        <label>
                            {t('logbook.entry.message')}
                        </label>
                        <textarea className="form-control" value={this.state.message}
                                  onChange={(e) => this.setState({message: e.target.value})}
                                  disabled={this.state.loading}/>
                        {(this.state.errors && this.state.errors.message) ? (
                            <span className="help-block">
                                                {t('logbook.message.error.' + this.state.errors.message)}
                            </span>
                        ) : null}
                    </div>
                    <div className="button-container text-right">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={this.state.loading}>
                            <i className={`fa fa-${this.state.loading ? 'spin fa-spinner' : 'save'} m-r-xs`}/> {t('default.save')}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

export default translate()(AddInformation);
